<ng-container *ngIf="hasData; else emptyState">
	<ng-container *ngFor="let obligor of obligors; let i = index">
	<section class="section-header" [class.next-obligor]="i > 0">
		<div class="header-content">
			<div class="header-left">
				<i class="fa-solid fa-user-shield"></i>
				<div class="header-text">
					<h1>Flujos del Obligado Solidario<ng-container *ngIf="obligors.length > 1"> {{ i + 1 }} de {{ obligors.length }}</ng-container></h1>
					<p class="header-subtitle" *ngIf="obligor.holderName">{{ obligor.holderName }}</p>
					<p class="header-subtitle" *ngIf="!obligor.holderName">Información de cuentas del aval del cliente</p>
				</div>
			</div>
			<div class="header-right">
				<div class="hero-stat" *ngIf="liquidityAverageOf(obligor) !== null">
					<i class="fa-solid fa-droplet"></i>
					<div class="hero-stat-content">
						<span class="hero-stat-label">Flujo de liquidez promedio (Excel)</span>
						<span class="hero-stat-value">{{ liquidityAverageOf(obligor) | currency:'MXN':'symbol-narrow':'1.2-2' }}</span>
					</div>
				</div>
				<p-tag [value]="obligor.flows.length + (obligor.flows.length === 1 ? ' cuenta' : ' cuentas')" severity="info"></p-tag>
			</div>
		</div>
	</section>

	<section class="info-card" *ngFor="let flow of obligor.flows">
		<div class="card-header">
			<i class="fa-solid fa-building-columns"></i>
			<h3>
				{{ flow.name }}
				<span class="account-number" *ngIf="flow.account">· {{ flow.account }}</span>
			</h3>
			<div class="header-tags">
				<p-tag [value]="flow.currency" [severity]="flow.currency === 'USD' ? 'info' : 'success'"></p-tag>
				<p-tag *ngIf="flow.exchangeRate" [value]="'T.C. ' + (flow.exchangeRate | number:'1.2-4')" severity="secondary"></p-tag>
				<p-tag *ngIf="flow.generalAverage !== null && flow.generalAverage !== undefined"
					[value]="'Promedio: ' + (flow.generalAverage | currency:flow.currency:'symbol-narrow':'1.0-0')"
					severity="secondary">
				</p-tag>
			</div>
		</div>
		<div class="card-content">
			<table class="data-table">
				<thead>
					<tr>
						<th>Periodo</th>
						<th class="num">Saldo inicial</th>
						<th class="num">Depósitos (+)</th>
						<th class="num">Cargos (−)</th>
						<th class="num">Saldo promedio</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let bal of flow.balances">
						<td>{{ bal.date | date:'mediumDate' }}</td>
						<td class="num">{{ bal.initialBalance | currency:flow.currency:'symbol-narrow':'1.2-2' }}</td>
						<td class="num">{{ bal.deposits | currency:flow.currency:'symbol-narrow':'1.2-2' }}</td>
						<td class="num">{{ bal.charges | currency:flow.currency:'symbol-narrow':'1.2-2' }}</td>
						<td class="num">{{ bal.averageBalance | currency:flow.currency:'symbol-narrow':'1.2-2' }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</section>
	</ng-container>
</ng-container>

<ng-template #emptyState>
	<div class="empty-state">
		<i class="fa-solid fa-user-shield"></i>
		<h3>Sin obligado solidario registrado</h3>
		<p>Si este lease tiene un obligado solidario, sus flujos aparecerán aquí tras subir el Excel de Análisis de Riesgo.</p>
	</div>
</ng-template>
